import * as React from "react";
import classNames from "classnames";
import { Link as RouterLink } from "@reach/router";
import { preventDefault, stopPropagation } from "../utils/browser";
import { StyledLink } from "../Link/StyledLink";
import { TO } from "./constants";
import { useNavigate } from "@reach/router";
import { useStyletron } from "kanopi-components/theme/useStyletron";

type ReachLinkProps = React.AnchorHTMLAttributes<HTMLAnchorElement> & {
  to?: string;
  href?: string;
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
  className?: string;
};
// TODO: Oh boy, this needs a refactor.
export function ReachLink(props: ReachLinkProps) {
  const { children, to, href, onClick, ...restProps } = props;
  const navigate = useNavigate();
  let _to = to || href;
  _to = _to === TO.back ? undefined : _to;
  const _onClick =
    to === TO.back ? preventDefault(handleBack) : preventDefault(onClick);
  const _as = to === TO.back || !_to ? undefined : RouterLink;
  function handleBack() {
    navigate(-1);
  }
  return (
    <StyledLink
      $as={_as}
      to={_to}
      onClick={stopPropagation(_onClick)}
      href="#"
      {...restProps}
    >
      {children}
    </StyledLink>
  );
}

function UnstyledLink(props: ReachLinkProps) {
  const { to, href, className, ...restProps } = props;
  const [css] = useStyletron();
  if (href) {
    return (
      <RouterLink
        to={to || href || ""}
        className={classNames(css({ textDecoration: "none" }), className)}
        {...restProps}
      />
    );
  }
  return <>{props.children}</>;
}

ReachLink.TO = TO;
ReachLink.Unstyled = UnstyledLink;
